'use strict';

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

// Custom polyfill to replace jQuery's ability to add class to an array of elements
window.NodeList.prototype.addClass = function (cssClass) {
    this.forEach(item => {
        item.classList.add(cssClass);
    });

    return this;
}

// Custom polyfill to replace jQuery's ability to add class to an array of elements
window.NodeList.prototype.removeClass = function (cssClass) {
    this.forEach(item => {
        item.classList.remove(cssClass);
    });

    return this;
}

// Custom polyfill to replace jQuery's ability to set attribute to an array of elements
window.NodeList.prototype.setAttribute = function (attribute, value) {
    this.forEach(item => {
        item.setAttribute(attribute, value);
    });

    return this;
}

// Custom polyfill to replace jQuery's ability to remove attribute from an array of elements
window.NodeList.prototype.removeAttribute = function (attribute) {
    this.forEach(item => {
        item.removeAttribute(attribute);
    });

    return this;
}

if (('requestFullscreen' in Element.prototype) === false) {
    Element.prototype.requestFullscreen = Element.prototype.mozRequestFullscreen || Element.prototype.webkitRequestFullscreen || Element.prototype.msRequestFullscreen;
}

if (('exitFullscreen' in Document.prototype) === false) {
    Document.prototype.exitFullscreen = document.mozExitFullscreen || document.webkitExitFullscreen || document.msExitFullscreen;
}

if (('fullscreenElement' in Document.prototype) === false) {
    Object.defineProperty(Document.prototype, 'fullscreenElement', {
        get: () => {
            return document.mozFullScreenElement || document.msFullscreenElement || document.webkitFullscreenElement;
        },
    });
}

if (('fullscreenEnabled' in Document.prototype) === false) {
    Object.defineProperty(Document.prototype, 'fullscreenEnabled', {
        get: () => {
            return document.mozFullScreenEnabled || document.msFullscreenEnabled || document.webkitFullscreenEnabled;
        },
    });
}

if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        var el = this;

        do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);

        return null;
    };
}

if (!Object.fromEntries) {
    Object.fromEntries = function (entries) {
        if (!entries || !entries[Symbol.iterator]) {
            throw new Error('Object.fromEntries() requires a single iterable argument');
        }

        let obj = {};

        for (let [key, value] of entries) {
            obj[key] = value;
        }

        return obj;
    }
}
